<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M6.5 3.5v13M6.5 6.2h8M6.5 10h6M6.5 13.8h9"/><circle cx="6.5" cy="6.2" r="1.4"/><circle cx="6.5" cy="13.8" r="1.4"/></svg>
</template>
